/* eslint-disable */
import axios from 'axios';
import { cloneDeep } from 'lodash';
import { API_KEY, URL } from '~/common/helpers/environment';

const stats = {
  find: async ({
    dateFrom,
    dateTo,
    environment,
    realm,
    interval,
    pipelineName,
    percentile,
    all = false,
    token
  }) => {
    try {
      // Encode path parameters to handle special characters safely
      const basePath = `runtime/realms/${encodeURIComponent(realm)}/stats${
        all ? '/all' : ''
      }`;

      // Use URLSearchParams for proper query parameter encoding
      const queryParams = new URLSearchParams();
      queryParams.append('environment', environment);
      queryParams.append('dateFrom', dateFrom);
      queryParams.append('dateTo', dateTo);
      queryParams.append('interval', interval);

      if (percentile && percentile !== '') {
        queryParams.append('percentiles', percentile);
      }

      if (pipelineName) {
        queryParams.append('pipelineName', pipelineName);
      }

      const url = `${basePath}?${queryParams.toString()}`;

      const request = await axios.get(`${URL}/${url}`, {
        headers: {
          apikey: API_KEY,
          Authorization: token
        }
      });

      const data = cloneDeep(request.data);

      const processDateHistogram = obj => {
        const replaceString = val => (typeof val === 'string' ? 0 : val);

        if (obj) {
          obj.avg = replaceString(obj.avg);
          obj.min = replaceString(obj.min);
          obj.max = replaceString(obj.max);
        }

        return obj;
      };

      data.runtimeStats.stats = processDateHistogram(data.runtimeStats.stats);
      data.runtimeStats.dateHistogramStats =
        data.runtimeStats.dateHistogramStats.map(processDateHistogram);

      data.runtimeStats.pipelineStats.forEach(pipeline => {
        pipeline.pipelineVersionStats.forEach(pipelineVersion => {
          pipelineVersion.dateHistogramStats =
            pipelineVersion.dateHistogramStats.map(processDateHistogram);
        });
      });

      return {
        data: {
          stats: data
        }
      };
    } catch (e) {
      console.error('findDirect - Error:', e);
      throw new Error(e);
    }
  }
};

export default stats;
